import { render } from "./SecretF.vue?vue&type=template&id=04080955&scoped=true"
import script from "./SecretF.vue?vue&type=script&lang=js"
export * from "./SecretF.vue?vue&type=script&lang=js"

import "./SecretF.vue?vue&type=style&index=0&id=04080955&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04080955"]])

export default __exports__